export default {
  SIGHTSEEING: 'sightseeing',
  ENTERTAINMENT: 'shows-and-entertainment',
  SHOPPING: 'shopping',
  FNB: 'fnb'
} 